import React from "react";
import {Col, Row} from "react-bootstrap";

const CardAddress = ({userData}) => {

        return (
            <Row className="card g-0 mb-3">
                <Col xs={12}>
                    <div className="card-body">
                        <div className="card-information">
                            <p className={'mb-0'}>{userData.firstName} {userData.lastName}</p>
                            <p className={'mb-0'}>{userData.address} {userData.address2 && "/ " +userData.address2}</p>
                            <p className={'mb-0'}>{userData.zip} {userData.city}</p>
                            <p className={'mb-0'}>{userData.country}</p>
                            <p className={'mb-0'}>{userData.phone}</p>
                        </div>
                    </div>
                </Col>
            </Row>
        )
}
export default CardAddress;